import { render, staticRenderFns } from "./CustomerProfessionalRecordPrint.vue?vue&type=template&id=bfd90fb6&scoped=true&"
import script from "./CustomerProfessionalRecordPrint.vue?vue&type=script&lang=js&"
export * from "./CustomerProfessionalRecordPrint.vue?vue&type=script&lang=js&"
import style0 from "./CustomerProfessionalRecordPrint.vue?vue&type=style&index=0&id=bfd90fb6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd90fb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VBtn,VCol,VIcon,VRow})
